import { Box, styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { ReactElement } from "react";

import { TooltipConfig } from "contexts/toolbars/reducer";

import { TooltipShortcut } from "./TooltipShortcut";

interface EnhancedTooltipProps {
    config: TooltipConfig;
    children: ReactElement;
    active?: boolean;
}

const ToggleButtonTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: 0,
        margin: 0,
        backgroundColor: "transparent",
    },
}));

export function EnhancedTooltip({ config, children, active = false }: EnhancedTooltipProps) {
    if (!config) {
        return children;
    }

    const tooltip = <TooltipShortcut toolName={config.toolName} shortcutKey={config.shortcutKey} />;

    return (
        <ToggleButtonTooltip
            title={
                <Box
                    data-testid={`enhanced-tooltip-${config.toolName}`}
                    sx={{
                        height: "36px",
                        padding: "4px 6px",
                        borderRadius: "8px",
                        backgroundColor: active ? "rgba(0, 0, 0, 0.80)" : "rgba(5, 5, 5, 0.46)",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        transition: "background-color 0.2s",
                        whiteSpace: "nowrap",
                        gap: "4px",
                    }}
                >
                    {tooltip}
                </Box>
            }
            placement={config.placement || "right"}
            open={config.alwaysVisible || undefined}
        >
            {children}
        </ToggleButtonTooltip>
    );
}
